import { useLayoutEffect } from 'react'
import { useThree } from '@react-three/fiber'
import * as THREE from 'three'
import { createEnvEquirect } from './textures'

// Generates a warm image-based environment (once) so the glass marbles and gold
// kintsugi seams pick up believable reflections. Not used as a visible background.
//
// Built in a *layout* effect (not a passive effect) so scene.environment is set
// BEFORE the first rendered frame — otherwise the marbles paint flat/reflection-less
// for a frame or two and the lighting visibly pops in on load. Also rebuilt if the
// WebGL context is lost and restored (its render-target texture dies with the context).
export default function SceneEnvironment() {
  const gl = useThree((state) => state.gl)
  const scene = useThree((state) => state.scene)

  useLayoutEffect(() => {
    let target: THREE.WebGLRenderTarget | null = null

    const build = () => {
      const equirect = createEnvEquirect()
      const pmrem = new THREE.PMREMGenerator(gl)
      pmrem.compileEquirectangularShader()
      target = pmrem.fromEquirectangular(equirect)
      scene.environment = target.texture
      pmrem.dispose()
      equirect.dispose()
    }

    build()

    const canvas = gl.domElement
    const onRestored = () => {
      target?.dispose()
      build()
    }
    canvas.addEventListener('webglcontextrestored', onRestored)

    return () => {
      canvas.removeEventListener('webglcontextrestored', onRestored)
      scene.environment = null
      target?.dispose()
    }
  }, [gl, scene])

  return null
}
